module.exports = __webpack_public_path__ + "images/style-4-959eeb474d6e46b2f2a062db95753b2a.jpg";